// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-header {\n    background-image: url('/images/purchases_head.svg');\n    min-height: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
